export default __webpack_public_path__ + "static/media/LT3.jpg";